const BASE62 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

export const base62Pattern = /^[0-9A-Za-z]{6}$/

export function floatToBase62(
	floatValue: number | undefined = Math.PI,
): string {
	if (isNaN(floatValue ?? Number.NaN)) {
		floatValue = Math.PI
	}

	// Normalize angle to [0, 2π] range
	let normalizedValue = floatValue! % (2 * Math.PI)
	if (normalizedValue < 0) {
		normalizedValue += 2 * Math.PI
	}

	const buffer = new ArrayBuffer(4)
	new DataView(buffer).setFloat32(0, normalizedValue)
	let int = new DataView(buffer).getUint32(0)
	let result = ''
	while (int > 0) {
		result = BASE62[int % 62] + result
		int = Math.floor(int / 62)
	}
	return result.padStart(6, '0')
}

export function base62ToFloat(base62Value: string): number {
	if (!/^[0-9A-Za-z]{6}$/.test(base62Value)) {
		throw new Error(
			`Invalid Base62 value provided for decoding: ${base62Value}`,
		)
	}
	const int = Array.from(base62Value).reduce((accumulator, character) => {
		return accumulator * 62 + BASE62.indexOf(character)
	}, 0)

	const buffer = new ArrayBuffer(4)
	new DataView(buffer).setUint32(0, int)
	return new DataView(buffer).getFloat32(0)
}
